import axios from "axios";

let baseURL = "http://aware.senseforth.com";
// let baseURL = 'http://ec2-13-233-208-207.ap-south-1.compute.amazonaws.com';

let axiosInstance = makeAxiosInstance();
let axiosInstance1 = makeAxiosInstance();

function makeAxiosInstance(options = { botID: null }, increaseTimeout) {
  return axios.create({
    baseURL: baseURL,
    withCredentials: true,
    timeout: increaseTimeout ? 300000 : 120000, //60000
    params: {
      botid: decodeURIComponent(options.botID) + "",
    },
    data: {
      botid: decodeURIComponent(options.botID) + "",
      mode: options.mode,
    },
  });
}

export function setBaseUrl(url, options = { botID: null }) {
  baseURL = url;
  axiosInstance = makeAxiosInstance(options);
  axiosInstance1 = makeAxiosInstance(options, true);
}

const DataAPI = (increaseTimeout = false) => {
  if (increaseTimeout) {
    return axiosInstance1;
  } else {
    return axiosInstance;
  }
};

export default DataAPI;

//Xpress and STPL and KYC fileUpload pb/cckd
const getGenericRouterURL = {
  local: "http://13.127.21.58/GenericChatBot/service/GenericApiRouter",
  dev: "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/service/GenericApiRouter",
  preprod: "https://chatbotpre.rbl.bank.in/service/GenericApiRouter",
  prod: "https://chatbot.rbl.bank.in/service/GenericApiRouter",
  poc: "https://chatbotuat.rbl.bank.in/rcb/GenericChatBot/service/GenericApiRouter",
};
//overlayfeedback
const getFeedbackURL = {
  local: "http://13.127.21.58/GenericChatBot/overallFeedback",
  dev: "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/overallFeedback",
  preprod: "https://chatbotpre.rbl.bank.in/overallFeedback/",
  prod: "https://chatbot.rbl.bank.in/overallFeedback",
  poc: "https://chatbotuat.rbl.bank.in/rcb/GenericChatBot/overallFeedback",
};

//sendAnalytics
const sendAnalyticsURL = {
  local: "http://13.127.21.58/GenericChatBot/bannerMenuAnalytics",
  dev: "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/bannerMenuAnalytics",
  preprod: "https://chatbotpre.rbl.bank.in/bannerMenuAnalytics",
  prod: "https://chatbot.rbl.bank.in/bannerMenuAnalytics",
  poc: "https://chatbotuat.rbl.bank.in/rcb/GenericChatBot/bannerMenuAnalytics",
};

//queryAnalytics

const queryAnalyticsURL = {
  local: "http://13.127.21.58/GenericChatBot/helloAnalytics",
  dev: "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/helloAnalytics",
  preprod: "https://chatbotpre.rbl.bank.in/helloAnalytics",
  prod: "https://chatbot.rbl.bank.in/helloAnalytics",
  poc: "https://chatbotuat.rbl.bank.in/rcb/GenericChatBot/helloAnalytics",
};

//popUpAnalyticsData

const popUpAnalyticsURL = {
  local: "http://13.127.21.58/GenericChatBot/popUpAnalytics",
  dev: "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/popUpAnalytics",
  preprod: "https://chatbotpre.rbl.bank.in/popUpAnalytics",
  prod: "https://chatbot.rbl.bank.in/popUpAnalytics",
  poc: "https://chatbotuat.rbl.bank.in/rcb/GenericChatBot/popUpAnalytics",
};

//abortedJourney

const abortedJourneyURL = {
  local: "http://13.127.21.58/GenericChatBot/abortedJourney",
  dev: "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/abortedJourney",
  preprod: "https://chatbotpre.rbl.bank.in/abortedJourney",
  prod: "https://chatbot.rbl.bank.in/abortedJourney",
  poc: "https://chatbotuat.rbl.bank.in/rcb/GenericChatBot/abortedJourney",
};

//CIFvaluePostURL

const CIFvaluePostURL = {
  local:
    "http://13.127.21.58/SenseforthOauthService/LoginServlet?loginMode=nbsso",
  dev: "https://chatbotdev.rbl.bank.in/sfoauth/SenseforthOauthService/LoginServlet?loginMode=nbsso",
  preprod:
    "https://chatbotpubpre.rbl.bank.in/SenseforthOauthService/LoginServlet?loginMode=nbsso",
  prod: "https://chatbotpub.rbl.bank.in/SenseforthOauthService/LoginServlet?loginMode=nbsso",
  poc: "https://chatbotuat.rbl.bank.in/sfoauth/SenseforthOauthService/LoginServlet?loginMode=nbsso",
};

//keepAlivePostURL
const keepAlivePostURL = {
  local: "https://13.127.21.58/corp/EBChatKeepAlive;jsessionid=",
  dev: "https://onlineuat.rbl.bank.in/corp/EBChatKeepAlive;jsessionid=",
  preprod: "https://ebankuat.rbl.bank.in/corp/EBChatKeepAlive;jsessionid=",
  prod: "https://online.rbl.bank.in/corp/EBChatKeepAlive;jsessionid=",
  poc: "https://onlineuat.rbl.bank.in/corp/EBChatKeepAlive;jsessionid=",
};

//Carousel_Banner

const getBannerActionURL = {
  local: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/Banner.txt",
  dev: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/Banner.txt",
  preprod: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/Banner.txt",
  prod: "https://webassets.rbl.bank.in/document/chatbot/Banner.txt", //prod
  poc: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/Banner.txt",
};

// Planned_Down_Time

const getPlannedDownTimeURL = {
  local:
    "https://d37h1lausy4x10.cloudfront.net/document/chatbot/plannedDowntime.txt",
  dev: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/plannedDowntime.txt",
  preprod:
    "https://d37h1lausy4x10.cloudfront.net/document/chatbot/plannedDowntime.txt",
  prod: "https://webassets.rbl.bank.in/document/chatbot/plannedDowntime.txt", //prod
  poc: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/plannedDowntime.txt",
};
//CNCLinks -- Quick links after could not understand and menu/option
const getCNCLinksURL = {
  local: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/CNCLinks.txt",
  dev: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/CNCLinks.txt",
  preprod:
    "https://d37h1lausy4x10.cloudfront.net/document/chatbot/CNCLinks.txt",
  prod: "https://webassets.rbl.bank.in/document/chatbot/CNCLinks.txt", //prod
  poc: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/CNCLinks.txt",
};

//STPRibbonJSON

const getSTPRibbonURL = {
  local: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/STPRibbon.txt",
  dev: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/STPRibbon.txt",
  preprod:
    "https://d37h1lausy4x10.cloudfront.net/document/chatbot/STPRibbon.txt",
  prod: "https://webassets.rbl.bank.in/document/chatbot/STPRibbon.txt", //prod
  poc: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/STPRibbon.txt",
};

//QuickLinkCMS

const getQuickLinkURL = {
  local:
    "https://d37h1lausy4x10.cloudfront.net/document/chatbot/quickLinks.txt",
  dev: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/quickLinks.txt",
  preprod:
    "https://d37h1lausy4x10.cloudfront.net/document/chatbot/quickLinks.txt",
  prod: "https://webassets.rbl.bank.in/document/chatbot/quickLinks.txt", //prod
  poc: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/quickLinks.txt",
};

//pb/ccrew

const getCCRewardsURL = {
  local:
    "http://13.127.21.58/SenseforthOauthService/LoginServlet?loginMode=rewsso",
  dev: "https://chatbotdev.rbl.bank.in/sfoauth/SenseforthOauthService/LoginServlet?loginMode=rewsso",
  preprod:
    "https://chatbotpubpre.rbl.bank.in/SenseforthOauthService/LoginServlet?loginMode=rewsso",
  prod: "https://chatbotpub.rbl.bank.in/SenseforthOauthService/LoginServlet?loginMode=rewsso",
  poc: "https://chatbotuat.rbl.bank.in/sfoauth/SenseforthOauthService/LoginServlet?loginMode=rewsso",
};
const loyaltyRewards = {
  dev: "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/service/saveLoyaltyRewardsPortal",
  preprod: "https://chatbotpre.rbl.bank.in/service/saveLoyaltyRewardsPortal",
  prod: "https://chatbot.rbl.bank.in/service/saveLoyaltyRewardsPortal",
};
const tncLinks = {
  dev: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/ChatbotTermsAndConditions.pdf",
  preprod: "https://d37h1lausy4x10.cloudfront.net/document/chatbot/ChatbotTermsAndConditions.pdf",
  prod: "https://webassets.rbl.bank.in/document/chatbot/ChatbotTermsAndConditions.pdf",
}

let env = "prod";
export const wrapperEndPoint = {
  genericRouterURL: getGenericRouterURL[env],
  feedbackURL: getFeedbackURL[env],
  analyticsURL: sendAnalyticsURL[env],
  queryAnalytics: queryAnalyticsURL[env],
  popUpAnalytics: popUpAnalyticsURL[env],
  abortedJourney: abortedJourneyURL[env],
  docUploadURL: getGenericRouterURL[env],
  CIFvalueURL: CIFvaluePostURL[env],
  keepAliveURL: keepAlivePostURL[env],
  BannerActionURL: getBannerActionURL[env],
  PlannedDownTimeURL: getPlannedDownTimeURL[env],
  CNCLinksURL: getCNCLinksURL[env],
  STPRibbonURL: getSTPRibbonURL[env],
  QuickLinkURL: getQuickLinkURL[env],
  CCRewardsURL: getCCRewardsURL[env],
  loyaltyRewards: loyaltyRewards[env],
  tncLinks: tncLinks[env],
};
